export default "__VITE_ASSET__4a70e323__"